import React from 'react';
import Panel from '../Panel';
import RedCross from '../../images/redCross.svg';
import { Wrapper, Icon } from './styles';
import { errorPropType } from '../../prop-types';
import Types from '../../redux/types';
import serverErrors from '../../pages/serverErrors';

export default class ErrorPanel extends React.Component {
  static propTypes = {
    error: errorPropType.isRequired,
  };

  getMessage() {
    const { error } = this.props;
    switch (error.type) {
      // Register
      case Types.REGISTER_EMAIL_ALREADY_TAKEN:
        return (
          <span>
            {serverErrors.usernameError}
            <br />
            To use this email address, simply <a href="/u/sign-in">sign in</a> before continuing.
          </span>
        );
      case Types.REGISTER_PASSWORD_ERROR:
        return serverErrors.passwordError;
      case Types.REGISTER_COGNITO_ERROR:
        return serverErrors.genericRegisterError;
      case Types.REGISTER_SESSION_AUTH_ERROR_DURING_SIGN_IN:
        return serverErrors.sessionAuthErrorFromSignUp;
      case Types.RECAPTCHA_ERROR:
        return serverErrors.reCaptchaError;

      // Marketing Preferences
      case Types.GET_PREFERENCES_ERROR:
        return serverErrors.apiGetError;
      case Types.UPDATE_PREFERENCES_ERROR:
        return serverErrors.apiUpdateError;

      // Sign in
      case Types.SIGN_IN_CREDENTIALS_ERROR:
        return serverErrors.usernamePasswordError;
      case Types.SIGN_IN_USER_DISABLED_ERROR:
        return (
          <span>
            {serverErrors.userDisabledError} <a href="/contact">here</a>.
          </span>
        );
      case Types.SIGN_IN_COGNITO_ERROR:
      case Types.SIGN_IN_SESSION_AUTH_ERROR:
        return serverErrors.genericSignInError;

      default:
        return serverErrors.genericError;
    }
  }

  render() {
    return (
      <Panel type="error">
        <Wrapper>
          <Icon>
            <img src={RedCross} alt="Error" />
          </Icon>
          <p data-error-panel>{this.getMessage()}</p>
        </Wrapper>
      </Panel>
    );
  }
}
